import {defineStore} from 'pinia'
import {ref} from "vue";
import axios from "axios";

export const useAuthStore = defineStore('auth', () => {

    const user = ref([]);
    const role = ref([]);
    const market = ref([]);
    const permissions = ref([]);
    const wallet = ref([]);
    const verificationFee = ref([]);

    const updateUserDetails = () => {
        const json = window.App?.me;
        user.value = {...json};
        market.value = {...window.App?.market};
        permissions.value = {...window.App?.Permissions};
        wallet.value = {...window.App?.wallet};
        verificationFee.value = window.App?.verificationFee ?? false;
        role.value = {...window.App?.role};
    }

    const refreshUser = async () => {
        try {
            const response = await axios.get('/apis/v4/me');
            user.value = {...response.data.data};
        } catch (error) {
            console.error('Failed to refresh user data:', error);
        }
    }

    return {
        user,
        market,
        role,
        permissions,
        updateUserDetails,
        refreshUser,
        wallet,
        verificationFee,
    }
})
